"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.serviceAreaDeserialize = void 0;
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const Location_1 = require("./Location");
const TripType_1 = require("./TripType");
function serviceAreaDeserialize(value) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        center: (0, Location_1.locationDeserialize)(object.center),
        radiusMi: (0, deserializeNumber_1.deserializeNumber)(object.radiusMi),
        availableTypes: (0, deserializeArray_1.default)(TripType_1.tripTypeDeserialize)(object.availableTypes),
    };
}
exports.serviceAreaDeserialize = serviceAreaDeserialize;
